<template>
  <div :data-ver="$root.content.version">
    <div class="wrapper__header">
      <div class="wrapper__headerImage">
        <div
          class="headerImage__shadow"
          :style="{
            backgroundImage: `url(${allImages[$root.content.header.image.src].ImgthumbBlurLarge})`
          }"
        />
        <div class="headerImage__background">
          <img
            class="headerImage"
            :src="allImages[$root.content.header.image.src].Img800"
            :alt="$root.content.header.image.alt"
          />
        </div>

        <div class="headerContent">
          <div class="headerContent__text">
            <div>
              <div v-scaletext>
                <h3 class="headerContent__text--title">{{ $root.content.header.title }}</h3>
              </div>
              <p
                v-balancetext
                v-for="(par, i) of $root.content.header.intro"
                :key="`intro-par-${i}`"
                class="headerContent__text--intro"
              >{{ par }}</p>
            </div>
          </div>

          <div class="headerContent__display">
            <img :src="$root.content.header.book" alt="Lawyer X book cover">
          </div>

          <div class="wrapper__parts">
            <a
              :class="{
                wrapper__link: true,
                'wrapper__link--hover': hoveredLink === part.type
              }"
              v-for="(part, i) in $root.content.parts"
              :key="`part-${i}`"
              :href="part.link"
              :style="style__link"
              @mouseover="mouseoverLink(part.type)"
              @mouseout="mouseoutLink"
              @click="trackClick(part.title)"
            >
              <div class="glow"></div>
              <p class="link__text link__text--title"><b>{{ part.title }}</b></p>
              <p v-if="part.subtitle" class="link__text link__text--subtitle"><i>{{ part.subtitle }}</i></p>
              <div class="icon__wrapper">
                <div :is="part.icon" fill="#efefef"></div>
              </div>
            </a>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>


<script>
import SimpleTitle from '@/components/headers/simple-title.vue'
import ResponsiveImage from '@/components/responsive-image.vue'
import scaleText from '@/functions/scaleTextToFit'

export default {
  name: 'link-block',
  props: [],
  components: {
    SimpleTitle,
    ResponsiveImage,
  },
  data () {
    return {
      allImages: this.$root.content.allImages,
      hoveredLink: null,
    }
  },
  methods: {
    mouseoverLink (val) {
      this.hoveredLink = val
    },
    mouseoutLink () {
      this.hoveredLink = null
    },
    trackClick (text) {
      ga('send', 'event', {
        // hitType: 'event',
        eventCategory: 'Link click',
        eventAction: 'link-click',
        eventLabel: text,
      })
    },
  },
  computed: {
    style__link () {
      const { allImages, header: {image: {src}} } = this.$root.content
      const colors = {
        // from: `rgb(${allImages[src].colors.Vibrant._rgb.join()})`,
        from: `rgb(205, 207, 210)`,
        // to: `rgb(${allImages[src].colors.DarkVibrant._rgb.join()})`,
        to: `rgb(225, 227, 230)`,
      }
      return {
        background: `rgba(0,0,0, 0.2)`
      }
    },
  },
}
</script>


<style scoped lang="sass">
@import index

.wrapper
  &__header
    // border: solid 1px lime
    // display: flex
    // max-width: 400px
    margin: 0 auto 32px auto
    align-items: flex-start
  &__headerImage
    h1
      position: relative
      z-index: 10
    .headerImage
      &__shadow
        position: absolute
        left: 0
        top: 0
        width: 100%
        height: 100%
        // background-repeat: no-repeat
        transform: translate(0, 1%)
        filter: blur(10px)
      &__background
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 100%
        z-index: 0
        .headerImage
          position: absolute
          top: 0
          left: 0
          width: 100%
          height: 100%
          object-fit: cover
          object-position: top center
          margin: 0

  &__parts
    display: flex
    flex-wrap: wrap
    width: 100%
  &__link
    // outline: solid 2px lime
    flex: 1 1 0
    min-width: 200px
    width: 50%

    // grid-column: span 3
    transition: all 200ms
    position: relative
    display: flex
    // flex-wrap: wrap
    flex-direction: column
    justify-content: space-between
    align-items: center
    // flex: 1 1 auto
    min-width: 130px
    width: 100%
    padding: 16px
    // margin: 4px
    // color: white
    text-decoration: none
    border-radius: 4px
    box-shadow: none
    &:visited
      border-color: none
    .glow
      transition: opacity 600ms
      position: absolute
      top: 0
      left: 0
      width: 100%
      height: 100%
      background: linear-gradient(45deg, rgba(0,0,0, 0.8), rgba(white, 0.5))
      opacity: 0
    &--hover
      // transform: translate(0, -8px)
      // text-shadow: 0 4px 6px rgba(black, 0.2)
      // +shadow-box-2
      .glow
        opacity: 1
      svg
        transform: translate(-50%, -50%) scale(2) !important
    p.link__text
      width: 100%
      text-align: center
      color: white !important
      font-weight: 300
      font-size: 14px
      word-break: break-none
      @media screen and (min-width: 500px)
        font-size: 16px
      line-height: 1.2
      text-decoration: none
      margin-bottom: 4px
      &:last-of-type
        margin-bottom: auto
      b
        // color: rgba(black, 0.8)
        font-weight: 600
        font-size: 20px
      i
        // color: rgba(black, 0.8)
        font-weight: 300
        font-size: 14px
    .icon__wrapper
      width: 50px
      height: 50px
      background: rgba(black, 0.6)
      border-radius: 50px
      margin-top: 8px
      svg
        width: 20px
        height: 20px
        left: 50%
        top: 50%
        transform: translate(-50%, -50%) scale(2)
  // &__social
  //   text-align: center
  //   margin-bottom: 16px !important
  //   display: block
  //   span
  //     display: inline-block
  //     vertical-align: top
  //     padding: 0 3px
  //     font-size: 24px
  //   .hashtag
  //     font-weight: 800
  //     // color: #41b58e
  //     color: #D8BD52


.headerContent
  // outline: solid 2px cyan
  // display: grid
  // grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)) // repeat(6, 1fr)
  display: flex
  flex-wrap: wrap
  // padding: 32px
  // grid-gap: 12px
  // align-items: center
  overflow: hidden
  &__display
    // outline: solid 1px hotpink
    display: flex
    flex: 1 1 0
    min-width: 250px
    width: 50%
    max-width: 400px
    // grid-column: span 2
    transform: scale(1.15)
    justify-content: center
    align-items: center
  &__text
    // outline: solid 1px hotpink
    flex: 1 1 0
    min-width: 250px
    width: 50%
    max-width: 500px
    // text-align: center
    // grid-column: span 2
    display: flex
    // align-items: center
    justify-content: center
    flex-direction: column
    padding: 24px
    @media screen and (min-width: 400px)
      padding: 32px
    @media screen and (min-width: 400px)
      padding: 40px
    &--title
      // text-align: center
      font-size: 64px
      margin: 0 auto
      color: white
      align-self: center
      text-shadow: 0 4px 16px rgba(black, 0.5)
    &--intro
      // text-align: center
      margin-bottom: 8px
      color: white
      text-shadow: 0 2px 16px rgba(black, 0.5)
      font-size: 16px
      @media screen and (min-width: 450px)
        font-size: 18px
      &:first-of-type
        font-weight: 800
        font-size: 20px
        @media screen and (min-width: 450px)
          font-size: 24px



</style>



// WEBPACK FOOTER //
// src/layouts/link-block.vue